var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    y: 0.613525,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22656 12.0333C9.22656 11.4561 9.42927 10.9799 9.83467 10.6048C10.2401 10.2296 10.7671 10.042 11.4158 10.042C12.0528 10.042 12.5683 10.2267 12.9621 10.5961C13.3675 10.9771 13.5702 11.4734 13.5702 12.0853C13.5702 12.6394 13.3733 13.1011 12.9795 13.4706C12.5741 13.8515 12.0412 14.042 11.381 14.042H11.3636C10.7266 14.042 10.2111 13.8515 9.8173 13.4706C9.42347 13.0896 9.22656 12.6105 9.22656 12.0333ZM9.45243 27.1848V15.6177H13.3096V27.1848H9.45243ZM15.4466 27.1848H19.3038V20.726C19.3038 20.3219 19.3501 20.0102 19.4428 19.7909C19.6049 19.3984 19.8511 19.0665 20.1812 18.7952C20.5113 18.5239 20.9254 18.3883 21.4235 18.3883C22.7208 18.3883 23.3694 19.2599 23.3694 21.003V27.1848H27.2266V20.5528C27.2266 18.8443 26.8212 17.5485 26.0103 16.6654C25.1995 15.7822 24.1281 15.3407 22.7961 15.3407C21.3019 15.3407 20.1378 15.9814 19.3038 17.2628V17.2974H19.2864L19.3038 17.2628V15.6177H15.4466C15.4698 15.9872 15.4814 17.1358 15.4814 19.0636C15.4814 20.9915 15.4698 23.6985 15.4466 27.1848Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInDark);
export default __webpack_public_path__ + "static/media/LinkedInDark.9ebd152802145d61e3fdd80039c32c11.svg";
export { ForwardRef as ReactComponent };